






















import { Component, Vue, Watch } from "vue-property-decorator";

import { activationCourse } from "@/api/product/order";
import { message } from "ant-design-vue";

@Component({
  components: {}
})
export default class experience extends Vue {
  private errorText: string = "";
  private mobile: string = "";
  async activation() {
    if (this.mobile) {
      let result = await activationCourse({
        mobile: this.mobile,
        productId: "pro_py1test",
        productType: "COURSE",
        expireTime: 1
      });
      if (result.isSuccess) {
        message.success("开通成功", 2);
        this.mobile = "";
      } else {
        if (result.message) {
          message.error(result.message, 3);
        } else {
          message.error("开通失败", 2);
        }
      }
    }
  }
}
